import { removeGiveawayLandingActiveItemTypeCreator, setGiveawayLandingActiveItemTypeCreator } from '../giveaway-selected-item.actions';
import { setGiveawayLandingVariantColorTypeCreator } from '../giveaway-color-and-size-variants.actions';
export const giveawaySelectedItemsInitialState = [];
export const giveawaySelectedItemReducerFactory = storePrefix => (state = giveawaySelectedItemsInitialState, action) => {
  switch (action.type) {
    case setGiveawayLandingActiveItemTypeCreator(storePrefix):
      {
        const product = action.payload;
        return Array.from(new Set([...state, product._id]));
      }
    case removeGiveawayLandingActiveItemTypeCreator(storePrefix):
      {
        if (Array.isArray(action.payload)) {
          return action.payload;
        }
        return state.filter(v => v !== action.payload);
      }
    case setGiveawayLandingVariantColorTypeCreator(storePrefix):
      {
        const {
          giveawaySelectedItemsState
        } = action.payload;
        return giveawaySelectedItemsState;
      }
    default:
      {
        return state;
      }
  }
};